import "clsx";
import { o as current_component, s as setContext, g as getContext } from "./index2.js";
function onDestroy(fn) {
  var context = (
    /** @type {Component} */
    current_component
  );
  (context.d ??= []).push(fn);
}
class ToastState {
  toasts = [];
  toastToTimeoutMap = /* @__PURE__ */ new Map();
  constructor() {
    onDestroy(() => {
      for (const timeout of this.toastToTimeoutMap.values()) {
        clearTimeout(timeout);
      }
    });
  }
  add(title, message, type = "info", durationMs = 5e3) {
    const id = (Date.now() * Math.random()).toString();
    this.toasts.push({ id, title, message, type });
    this.toastToTimeoutMap.set(id, setTimeout(() => this.remove(id), durationMs));
  }
  remove(id) {
    const timeout = this.toastToTimeoutMap.get(id);
    if (timeout) {
      clearTimeout(timeout);
      this.toastToTimeoutMap.delete(id);
    }
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
  }
}
const TOAST_KEY = Symbol("toastkey");
function setToastState() {
  return setContext(TOAST_KEY, new ToastState());
}
function getToastState() {
  return getContext(TOAST_KEY);
}
export {
  getToastState as g,
  setToastState as s
};
